module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_vm._l((_vm.items), function(item, key) {
    return _c('div', {
      staticClass: "col-md-3"
    }, [_c('div', [_c('label', {
      staticClass: "control-label"
    }, [_vm._v(" " + _vm._s(item.label) + " ")])]), _vm._v(" "), (item.type === 'date') ? _c('datepicker', {
      attrs: {
        "language": "es",
        "name": item.name,
        "inputClass": item.class,
        "wrapperClass": item.divclass,
        "placeholder": item.placeholder,
        "format": "YYYY-MM-DD H:i:s",
        "disabled": item.disabled
      },
      on: {
        "input": _vm.updateDate
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((item.errors), function(error) {
      return (item.type === 'date') ? _c('div', {
        staticStyle: {
          "margin-left": "18px"
        },
        attrs: {
          "id": "errors"
        },
        model: {
          value: (item.errors),
          callback: function($$v) {
            _vm.$set(item, "errors", $$v)
          },
          expression: "item.errors"
        }
      }, [_c('div', {
        staticClass: "clearfix"
      }), _vm._v("\n                " + _vm._s(error) + "\n                "), _vm._m(1, true)]) : _vm._e()
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-left"
  }, [_c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "value": "Exportar",
      "name": "Guardar"
    },
    on: {
      "click": _vm.exportpqr
    }
  })])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Exporte")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix"
  }, [_c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-479189bc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/emt-form-export.vue
// module id = 229
// module chunks = 0